import React from 'react';
import {
  NavLink,
  Outlet,
  useLocation,
  useOutletContext,
} from 'react-router-dom';
import { useIntl } from 'react-intl';
import { OutletContextParams } from './delivery-orders-screen';
import { TransportationLinesCount } from './transportation-lines-count';
import { usePackagedDeliveryOrdersInfo } from '../../../api/delivery';
import { toMoney } from '../../../utils/common.utils';
import { Button } from 'rsuite';
import { DeliveryOrderSendToRussiaBulk } from './delivery-order-send-to-russia-bulk-modal';
import { ModalsService } from '../../../services/modals.service';
import { mutate as globalMutate } from 'swr';
import { cache } from 'swr/_internal';
import moment from 'moment';
import { api } from '../../../services/api';

export const DeliveryOrdersAssemblyTabs = () => {
  const intl = useIntl();
  const context: OutletContextParams = useOutletContext();
  const location = useLocation();
  const paths = location.pathname.split('/');
  const { data: packagedInfo } = usePackagedDeliveryOrdersInfo(
    paths?.[4] !== 'packaged',
  );

  const tabs = [
    {
      title: intl.formatMessage({
        id: 'deliveryOrders.tab-label.assembly-standalone',
        defaultMessage: 'Индивидуальные',
        description: 'Надпись на вкладке',
      }),
      path: 'standalone',
      type: 'standalone' as const,
    },
    {
      title: intl.formatMessage({
        id: 'deliveryOrders.tab-label.assembly-combined',
        defaultMessage: 'Сборные',
        description: 'Надпись на вкладке',
      }),
      path: 'combined',
      type: 'combined' as const,
    },
    {
      title: intl.formatMessage({
        id: 'deliveryOrders.tab-label.assembly-packaged',
        defaultMessage: 'Упакованные',
        description: 'Надпись на вкладке',
      }),
      path: 'packaged',
      type: 'packaged' as const,
    },
  ];

  const submit = async (date?: Date) => {
    await api.post(`/delivery-order/send-to-russia-bulk`, {
      ids: context.selectedOrders,
      date: date ? moment(date, 'DD.MM.YYYY HH:mm').toISOString() : undefined,
    });
  };

  return (
    <>
      <div className="d-flex gap-2 mb-4">
        <ul className="nav nav-pills d-inline-flex">
          {tabs.map((item) => (
            <li className="nav-item" key={item.title}>
              <NavLink to={item.path} className="nav-link text-decoration-none">
                {item.title}{' '}
                <span>
                  (
                  <TransportationLinesCount
                    name={context.debouncedInternalId}
                    status={
                      item.type !== 'packaged' ? ['created'] : ['packaged']
                    }
                    types={item.type !== 'packaged' ? [item.type] : undefined}
                    linked={context.linked}
                    supplierId={context.selectSupplier}
                  />
                  )
                </span>
              </NavLink>
            </li>
          ))}
        </ul>
        {packagedInfo ? (
          <>
            <div className={'d-flex gap-2 fs-18 align-items-center'}>
              {' '}
              {intl.formatMessage({
                id: 'deliveryOrder.item',
                defaultMessage: 'Мест',
                description: 'Надпись на вкладке',
              })}{' '}
              {packagedInfo.countAmount}; {packagedInfo.volume}{' '}
              {intl.formatMessage({
                id: 'deliveryOrder.volume',
                defaultMessage: 'м³',
                description: 'Надпись на вкладке',
              })}
              ; {packagedInfo.weight} $
              {intl.formatMessage({
                id: 'deliveryOrder.kg',
                defaultMessage: 'кг',
                description: 'Надпись на вкладке',
              })}
              ; {toMoney(packagedInfo.priceCny, 'cny')};{' '}
              {toMoney(packagedInfo.priceUsd, 'usd')}
            </div>
            <div className={' mleft-auto d-flex gap-2 '}>
              <div className={'d-flex gap-1 fs-18 fw-600 align-items-center'}>
                <span>
                  {intl.formatMessage({
                    id: 'deliveryOrder.all',
                    defaultMessage: 'Все',
                    description: 'Надпись на вкладке',
                  })}
                </span>
                <input
                  className="form-check-input p-2 border-2 cursor-pointer mb-1"
                  type="checkbox"
                  checked={context.selectAllOrders}
                  onChange={() => {
                    context.setSelectAllOrders(!context.selectAllOrders);
                  }}
                />
              </div>
              <Button
                className={'btn btn-success'}
                disabled={!context.selectedOrders.length}
                onClick={async () => {
                  const response = await api.post(
                    `/delivery-order/check-sent-dates`,
                    {
                      ids: context.selectedOrders.map(
                        (order) => order.internalId,
                      ),
                    },
                  );
                  ModalsService.createModal(DeliveryOrderSendToRussiaBulk, {
                    ids: context.selectedOrders.map(
                      (order) => order.internalId,
                    ),
                    idsWithoutDates: response.data || [],
                    onSubmit: async (form) => {
                      await submit(form.date);
                      for (const key of cache.keys()) {
                        globalMutate(key, undefined, true);
                      }
                    },
                  });
                }}
              >
                {intl.formatMessage({
                  id: 'deliveryOrder.moveToSent',
                  defaultMessage: 'Перенести в отправленные',
                  description: 'Надпись на вкладке',
                })}
              </Button>
            </div>
          </>
        ) : null}
      </div>
      <Outlet context={context} />
    </>
  );
};
